<template>
  <li
    class="dropdown-item"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <a>
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: "OptionsButtonItem",
  inheritAttrs: false,
};
</script>

<style scoped>
li {
  cursor: pointer
}

li a {
  display: inline-block;
  width: 100%;
}
</style>
